/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import ContenidoForm from './ContenidoForm';
import * as validations from '../../validations/validations';
import * as contenidoActions from '../../actions/contenidoActions';
 
import * as tipoContenidoActions from '../../actions/tipoContenidoActions';
import * as crucigramaActions from '../../actions/crucigramaActions';
import * as formularioActions from '../../actions/formularioActions';
import withRouter from '../common/withRouter';

import {  useParams } from "react-router-dom";

import { Segment} from 'semantic-ui-react'; 
import moment from 'moment';
import $ from 'jquery';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import {getMargenes} from '../../util/';
import {genericFormattedForDropdownByNombre, genericFormattedForDropdown} from '../../selectors/selectors';

import {usuarioActual} from '../../util';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';


class ManageContenidoForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
			contenido:{
                    }
		};
		
	}
    
    
    componentDidMount(){
        usuarioActual(this, "contenido",true).then( (usuario)=>{
        let id=this.props.id;
        this.props.tipoContenidoActions.getTipoContenidoCombo(usuario).then( ()=>{ 
           
        }) 
        .catch(error=>{ 
          toastr.error(error); 
        });         
         this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);
         this.props.formularioActions.getFormularioCombo(usuario).then(()=>{ 
           
        })
        .catch(error=>{
          toastr.error(error);
        }); 
             
             
        this.props.crucigramaActions.getCrucigramaCombo(usuario).then(()=>{ 
           
        })
        .catch(error=>{
          toastr.error(error);
        });      
             
             
            if(id && id>0 ){
            
                this.props.contenidoActions.getContenido(id, usuario).then( contenido=>{
                    this.setState({"contenido":contenido});
                    
                    this.props.contenidoActions.getArchivosDisponibles(contenido.idTipo, this.props.user, contenido.prefijo).then( archivos=>{
                        this.setState({"archivos":archivos});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
           })
            .catch(error=>{
              toastr.error(error);
            }); 
            }
       })
        .catch(error=>{
          toastr.error(error);
        }); 
		
   
		
    }
    
    
    goBack=()=>{
         this.props.navigate(-1);
    }

    handleChange=(event, data)=> {

        let contenido = this.state.contenido;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		contenido[field[0]]= value;
		else{
             if(!contenido[field[0]]){
                    contenido[field[0]]={}
                }
			contenido[field[0]][field[1]]= value;
		}
        
        
        /*
		if(field=="idTipo" && contenido.prefijo!=""){
       
            this.props.contenidoActions.getArchivosDisponibles(contenido.idTipo, this.props.user, value).then( archivos=>{
               this.setState({"archivos":archivos});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        */
        this.setState({"contenido": contenido});
    }
    
    
    onBuscar=(event)=>{
        event.preventDefault();
        let contenido = this.state.contenido;
        
        if( contenido.idTipo!="" && contenido.prefijo!=""){
            this.props.contenidoActions.getArchivosDisponibles(contenido.idTipo, this.props.user, contenido.prefijo).then( archivos=>{
               this.setState({"archivos":archivos});
           })
            .catch(error=>{
              toastr.error(error);
            }); 
        }
        
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let contenido=this.state.contenido;
              
        if(!validations.requerido(contenido.titulo)){
            errors.titulo=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(contenido.descripcion)){
            errors.descripcion=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(contenido.tiempo)){
            errors.tiempo=true;
            formIsValid=false;
        }
        
        
        if((contenido.idTipo==26||contenido.idTipo==27||contenido.idTipo==29) && !validations.requerido(contenido.archivo)){
            errors.archivo=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(contenido.idTipo)){
            errors.idTipo=true;
            formIsValid=false;
        }
        
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
       
        
        this.props.contenidoActions.save(this.state.contenido, this.props.user).then(() => {
            toastr.success("Registro guardado!!!.");
            //this.props.navigate('/contenidos');
            this.props.navigate(-1);
        });
        
    }

       
    render() {	
         let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		
		return (
              <Segment  style={margenes}>
                <ContenidoForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.contenido}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    archivos={genericFormattedForDropdown(this.state.archivos)}
                    tipoContenidoCombo={genericFormattedForDropdown(this.props.tipoContenidoCombo)}
                    formularioCombo={genericFormattedForDropdown(this.props.formularioCombo)}
                    crucigramaCombo={genericFormattedForDropdown(this.props.crucigramaCombo)}
                    onBuscar={this.onBuscar}
                    goBack={this.goBack}
                    
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        color:state.color,
        tipoContenidoCombo:state.tipoContenidoCombo,
        user:state.user, 
        idioma:state.idioma,
        strings:state.strings,
        form:state.form,
        formularioCombo: state.formularioCombo,
        crucigramaCombo: state.crucigramaCombo
    }

}

function mapDispatchToProps(dispatch){

	return {   
        menuActions:bindActionCreators(menuActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
        tipoContenidoActions: bindActionCreators(tipoContenidoActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        contenidoActions: bindActionCreators(contenidoActions, dispatch),
        formularioActions: bindActionCreators(formularioActions, dispatch),
        crucigramaActions: bindActionCreators(crucigramaActions, dispatch),
	};
}



export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageContenidoForm));